import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="flex items-center gap-2 text-xl font-bold font-heading text-foreground-900 mb-4">
                <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg text-sm font-bold">
                  漫
                </span>
                韩漫屋
              </Link>
              <p className="text-sm text-foreground-500 leading-relaxed">
                韩漫屋致力于为广大韩漫爱好者提供最新、最全、最高清的韩国漫画在线阅读服务。采用下拉式阅读界面，带给您流畅的阅读体验。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">
                <a href="#footer-categories" className="hover:text-primary-500 transition-colors duration-200">漫画分类</a>
              </h4>
              <ul className="space-y-2.5">
                {categories.slice(0, 6).map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">
                <a href="#footer-links" className="hover:text-primary-500 transition-colors duration-200">快速链接</a>
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200">
                    关于我们
                  </Link>
                </li>
                <li>
                  <Link to="/category/romance" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200">
                    恋爱韩漫
                  </Link>
                </li>
                <li>
                  <Link to="/category/fantasy" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200">
                    奇幻韩漫
                  </Link>
                </li>
                <li>
                  <Link to="/category/action" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200">
                    动作韩漫
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">
                <a href="#footer-contact" className="hover:text-primary-500 transition-colors duration-200">联系我们</a>
              </h4>
              <ul className="space-y-2.5 text-sm text-foreground-500">
                <li className="flex items-center gap-2">
                  <i className="ri-mail-line text-primary-500" />
                  <span>contact@hanmanwu.com</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-global-line text-primary-500" />
                  <span>www.hanmanwu.com</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-time-line text-primary-500" />
                  <span>每日更新 07:00-23:00</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-background-200/70 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; {new Date().getFullYear()} 韩漫屋 HanManWu - 韩国漫画大全,免费韩漫在线观看,下拉式,好看的韩国漫画
            </p>
            <div className="flex items-center gap-4">
              <a
                href="#"
                className="w-8 h-8 flex items-center justify-center rounded-md text-foreground-400 hover:text-primary-500 hover:bg-background-200 transition-colors duration-200"
                aria-label="微信"
                rel="nofollow"
              >
                <i className="ri-wechat-line text-sm" />
              </a>
              <a
                href="#"
                className="w-8 h-8 flex items-center justify-center rounded-md text-foreground-400 hover:text-primary-500 hover:bg-background-200 transition-colors duration-200"
                aria-label="微博"
                rel="nofollow"
              >
                <i className="ri-weibo-line text-sm" />
              </a>
              <a
                href="#"
                className="w-8 h-8 flex items-center justify-center rounded-md text-foreground-400 hover:text-primary-500 hover:bg-background-200 transition-colors duration-200"
                aria-label="QQ"
                rel="nofollow"
              >
                <i className="ri-qq-line text-sm" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}